import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FLINT } from 'HubStyleTokens/colors';
import { H2, H7 } from 'UIComponents/elements/headings';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
/* @ts-expect-error module is untyped */

import { isQa } from '../../../utils/env';
import { getServices } from '../../../slices/serviceCatalogSlice';
import PillButton from './FindPartnerWizardPillButton';
import { WIZARD_STEP_CLASSNAME, WIZARD_STEP_HEIGHT } from './FindPartnerWizard'; // TODO: MISSING "CUSTOMER INTEGRATIONS"

const POPULAR_SERVICE_IDS = isQa() ? [1290, 1309, 1308, 1301, 1298, 48553, 1288, 1297, 1305] : [5, 24, 23, 16, 13, 39001, 3, 12, 20];

function SelectItem({
  children,
  option
}) {
  const {
    brief
  } = option;
  const showTooltip = !!brief && !Object.keys(option).includes('help');

  if (!showTooltip) {
    return /*#__PURE__*/_jsx("span", {
      children: children
    });
  }

  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    className: "p-right-4",
    direction: "row",
    justify: "between",
    children: [children, /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      title: brief,
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: FLINT,
        name: "info",
        size: "xs"
      })
    })]
  });
}

export default function FindPartnerWizardServiceStep({
  filters,
  onFilterChange
}) {
  const services = useSelector(getServices);
  const [showMore, setShowMore] = useState(false);
  const options = useMemo(() => services.map(service => ({
    brief: service.brief,
    text: service.name,
    value: service.id
  })), [services]);
  const renderedPopularServices = useMemo(() => {
    const result = POPULAR_SERVICE_IDS.filter(id => !filters.service.includes(id)).map(id => services.find(service => service.id === id));
    const expandable = result.length > 5;

    if (result.length < 5) {
      setShowMore(false);
    }

    if (!showMore) {
      result.splice(5);
    }

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!!result.length && /*#__PURE__*/_jsx(H7, {
        className: "m-top-7 m-bottom-2 ",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.popularServices"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: result.map(service => /*#__PURE__*/_jsx(PillButton, {
          onClick: () => onFilterChange('service', [...filters.service, service.id]),
          tooltipTitle: service.brief,
          children: service.name
        }, service.id))
      }), !showMore && expandable && /*#__PURE__*/_jsx(UIButton, {
        className: "p-top-4",
        onClick: () => setShowMore(true),
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.seeMore"
        })
      })]
    });
  }, [filters, onFilterChange, services, showMore]);
  return /*#__PURE__*/_jsxs(UIWizardStep, {
    className: WIZARD_STEP_CLASSNAME,
    style: {
      height: WIZARD_STEP_HEIGHT
    },
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-11",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.service.title"
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      anchorType: "combined",
      itemComponent: SelectItem,
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => onFilterChange('service', value),
      multi: true,
      value: filters.service
    }), renderedPopularServices]
  });
}